import React from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";
import CardContent from "./card-content";
import CustomLink from "@/bit/components/components.custom-link";
import { BEHAVIOUR_KIND } from "@/bit/components/components.custom-link/utils";
const CmsEditableGroupIcons = dynamic(() =>
  import("@/bit/components/components.cms-block.cms-editable-group-icons")
);
const TextInfo = dynamic(() => import("@/bit/components/components.text"));

const DETAIL_CARD_TAGGING_INFO = {
  componentName: "DetailCard",
  componentVariation: "",
  componentContent: "Modal Ficha",
  eventType: "click",
};

/**
 * Componente que permite crear cards de ofertas
 */
function SmallFeatureCard({ cardProps, cmsHandler, index, alias, blockName, frontalListToDelete }) {
  const {
    "cms-atom-link-1": cardLink,
    inherited
  } = cardProps;

  const cardHasLink =
  cardLink && (cardLink.href || cardLink.onClick);
  
  // Lógica para que SEO rastree un cms modal ficha cuando la card es clickable
  let hrefSeoElement = "";
  const isCmsModalPageHref =
    cardLink?.href?.indexOf(BEHAVIOUR_KIND.CMS_MODAL_PAGE) > -1;
  if (isCmsModalPageHref) {
    hrefSeoElement = cardLink?.href.replace(
      BEHAVIOUR_KIND.CMS_MODAL_PAGE,
      ""
    );
  }

  if (cardHasLink) {
    if (!cardLink.taggingInfo) {
      cardLink.taggingInfo = {};
    }
    cardLink.taggingInfo = {
      ...DETAIL_CARD_TAGGING_INFO,
      ...cardLink.taggingInfo,
    };
  }

  
  // LOGICA ENTORNO PRODUCTIVO
  let CardTemplate = cardHasLink ? 
  <>
    {hrefSeoElement && (
      <CustomLink
        {...cardLink}
        taggingInfo={{}}
        href={hrefSeoElement}
        style={{ display: "none" }}
      />
    )}
    <CardContent cardProps={cardProps} />
    <CustomLink
        {...cardLink}
        className="block-link"
        cydata="DetailCard CustomLink"
      />
  </>: (
    <CardContent cardProps={cardProps} />
  ) ;

  // LOGICA ENTORNO CMS
  if (cmsHandler && !inherited) {
    CardTemplate = (
      <>
        {/* Bolitas de edicion aqui */}
        <CmsEditableGroupIcons
          elementProps={{
            ...cardProps,            
            editName: "cms-block.cms-small-feature-card",
          }}
          deleteProps={{
            index,
            itemIdDotNotation: `${blockName}.cms-small-feature-card-1`,
            alias,
            frontalListToDelete,
          }}
          visibleTools={{
            hiring: false,
            edit: true,
            deleteItem: true,
          }}
          cmsHandler={cmsHandler}
        />
        <CardContent cardProps={cardProps} cmsHandler={cmsHandler} />
        <CustomLink
          {...cardLink}
          cydata="SmallCard CustomLink"
          cmsHandler={cmsHandler}
        />
      </>
    );
  }

  if (cmsHandler && inherited) {
    CardTemplate = (
      <>
        {/* Cartel Oriogen Card al heredar */}
        <div className="inherited-text">
          <TextInfo
            color="white"
            align="center"
            size="t4"
            text={`Esta card pertenece a la ficha ${inherited}. Para cambiar su contenido dirígase a la página correspondiente.`}
          />
        </div>
        <CardContent
          cardProps={{ ...cardProps, className: "inherited-card" }}
        />
      </>
    );
  }

  return (
    <div className="small-feature-card">
      {CardTemplate}
      <style jsx>{`.small-feature-card {
  position: relative;
  height: 100%;  
  :global(.inherited-text) {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(88, 88, 88, 0.7); /* Velo oscuro semitransparente */
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    border-radius: 8px;
    backdrop-filter: blur(4px); /* Difumina el fondo detrás del velo */
  }
  .edit-component {
    border-radius: 16px;
    background: rgba(0, 0, 0, 0.8);
    right: 40px;
    width: 32px;
  }
}
`}</style>
    </div>
  );
}

SmallFeatureCard.propTypes = {
  /**
   * {
   *  "info": "Campo para el filtrado de la card, se puede poner un único valor o separar por ',' varios valores",
   *  "kind": "both",
   *  "beautifulName": "Categoria"
   * }
   */
  category: PropTypes.string,
  /**
   * {
   *  "info": "Campo para el ordenado de cards",
   *  "kind": "both",
   *  "beautifulName": "Fecha y hora"
   * }
   */
  datetime: PropTypes.string,
  /**
   * {
   *  "info": "Ocultar card",
   *  "kind": "dev",
   *  "beautifulName": "Ocultar card"
   * }
   */
  hide: PropTypes.bool,
};

SmallFeatureCard.defaultProps = {
  category: "todos",
  datetime: "",
  hide: false,
};
export default SmallFeatureCard;
